import axios from 'axios';

const API_BASE_URL = 'https://stan-backend.stanleyisaac134.workers.dev/api';

export class StanAPIService {
  private static getAuthHeaders() {
    const token = localStorage.getItem('stan_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  static async sendChatMessage(projectId: string, message: string, source: string = 'ide') {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/projects/${projectId}/chat`,
        {
          message,
          source,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders(),
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw new Error('Failed to send message');
    }
  }

  static async getProject(projectId: string) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/projects/${projectId}`,
        {
          headers: this.getAuthHeaders(),
        }
      );

      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw new Error('Failed to fetch project');
    }
  }

  static async buildProject(projectId: string) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/projects/${projectId}/build`,
        {},
        {
          headers: this.getAuthHeaders(),
        }
      );

      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw new Error('Failed to build project');
    }
  }
}